module.exports = __webpack_public_path__ + "b38c59200397338d5c2e49fc7d82583e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fortinet_2022_chart.png
// module id = 1680
// module chunks = 0